"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class ImprintLink extends _react.default.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'ml-3',
      style: {
        flex: '1 1 auto',
        position: 'relative',
        minHeight: '3rem'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        bottom: '1rem',
        left: '0'
      }
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: '/imprint',
      className: 'imprint-link'
    }, "Imprint - Privacy Policy - Legal")));
  }
}
var _default = exports.default = ImprintLink;
module.exports = exports.default;